export default "__VITE_ASSET__Blw9g7lo__"